<template>
  <div class="home-form">
    <modal-data-form
      :show-modal="store.showModalDataForm"
      :title="title"
      :on-save="onSave"
    >
      <field-group-form :group-label="$t('Foto')">
        <v-row>
          <v-col class="ma-0 py-0 pt-6" cols="12">
            <validation-provider
              v-slot="{ errors }"
              name="fotoPerfil"
              rules="size:20480"
            >
              <v-file-input
                v-model="fields.fotoPerfil"
                chips
                filled
                prepend-icon="mdi-camera"
                :error-messages="errors"
                :show-size="true"
                :truncate-length="$vuetify.breakpoint.xsOnly ? 20 : 50"
                :placeholder="$t('click_para_inserir_foto')"
                accept="image/*"
              />
            </validation-provider>
          </v-col>
        </v-row>
      </field-group-form>
    </modal-data-form>
  </div>
</template>

<script>
import ModalDataForm from "@/components/forms/modal-data-form";
import FieldGroupForm from "@/components/forms/field-group-form";
import { extend, ValidationProvider } from "vee-validate";
import { size } from "vee-validate/dist/rules";
import { updateData, uploadFile } from "@/services";

export default {
  props: {
    title: {
      type: String,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { FieldGroupForm, ModalDataForm, ValidationProvider },
  data: () => ({
    fields: {
      fotoPerfil: null,
    },
  }),
  watch: {
    "store.showModalDataForm"() {
      this.fields.fotoPerfil = null;
    },
  },
  computed: {
    store() {
      return this.$store.state;
    },
  },
  beforeMount() {
    this.$store.commit("setShowModalDataForm", false);

    extend("size", {
      ...size,
      message: this.$t("arquivo_menos_de_20MB"),
    });
  },
  methods: {
    onSave() {
      uploadFile(this, "pessoa", this.fields.fotoPerfil, "fotoPerfil", (data) =>
        updateData(this, "pessoa", { ...this.fields, ...data })
      );
    },
  },
};
</script>

<style scoped></style>
